import { Navigate, useLocation } from 'react-router-dom';
// import { LangProvider } from '@/context/LangProvider';
import '@/css/scrollbar.css';
import Routes from '@/router/routes';
import useAuthAdminStore from '@/store/AdminAuthStore';
import SuperAdminContent from '@/pages/super-admin/SuperAdminContent';
import useErrorAdminStore from '@/store/AdminErrorStore';
import Error404Page from '@/pages/error/Error404Page';

function AuthWrapper() {
  const authAdminToken = useAuthAdminStore((state) => state.authAdminToken);
  const location = useLocation();
  const showError = useErrorAdminStore((state) => state.showError);

  if (showError) return <Error404Page />;

  return authAdminToken ? (
    // <LangProvider>
    <SuperAdminContent />
  ) : (
    // </LangProvider>
    <Navigate to={Routes.login.path} state={{ from: location.pathname }} replace />
  );
}

export default AuthWrapper;
